import {paDom} from "./paDom";

export const paDomNodeList = {
    init() {
        /** make edge understand forEach on node elements */
        NodeList.prototype.forEach = Array.prototype.forEach;

        NodeList.prototype.addClass = this.addClass;
        NodeList.prototype.removeClass = this.removeClass;
        NodeList.prototype.click = this.click;
        NodeList.prototype.toArray = this.toArray;

        /** to create NodeList from Array with Reflect.construct(Array, [], NodeList); **/
        NodeList.prototype.item = function item(i) {
            return this[+i || 0];
        };
    },
    addClass(classToAdd) {
        this.forEach(function (el, i) {
            el.classList.add(classToAdd);
        });
        return this;
    },
    removeClass(classToRemove) {
        this.forEach(function (el, i) {
            el.classList.remove(classToRemove);
        });
        return this;
    },
    click(callback) {
        this.forEach(function (el, i) {
            paDom.bind(el, callback);
        });
        return this;
    },
    toArray() {
        return Array.from(this);
    }

};



// WEBPACK FOOTER //
// ./src/js/framework/paDomNodeList.js